import { useContext, useState } from 'react';

import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import Logo from '../../Assets/Images/logo.png';
import { EventContext } from '../../Contexts/EventContext';
import Header from './Header';
import Sidebar from './Sidebar';

const Master = ({
  children,
  showSidebar = true,
  containerFullWidth = false,
  showFormSidebar = false,
  sidebarComponent,
  headerFixed = false,
  title = null,
}) => {
  const { pathname } = useLocation();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const eventContext = useContext(EventContext);
  return (
    <>
      <Header headerFixed={headerFixed} showMobileMenu={setShowMobileMenu} />
      <Helmet>
        <title>{title ?? eventContext?.setting?.name}</title>
      </Helmet>
      <main className='w-100'>
        <section
          className={`container-fluid ${
            containerFullWidth ? 'mx-0 px-0 overflow-x-hidden' : ''
          }`}
        >
          <div className='row mx-0'>
            {showSidebar && (
              <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 bg-white'>
                <Sidebar />
                {showFormSidebar && sidebarComponent}
              </div>
            )}
            <div
              className={`${
                showSidebar
                  ? 'col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9'
                  : 'w-100'
              }`}
            >
              {children}
            </div>
          </div>
        </section>
        {pathname === '/' && (
          <div
            style={{
              position: 'fixed',
              left: '25px',
              bottom: '10px',
            }}
          >
            {parse(eventContext?.setting?.e_namad ?? '')}
          </div>
        )}
      </main>
      {showMobileMenu && (
        <>
          <div
            className='backdrop bg-dark'
            onClick={() => setShowMobileMenu(false)}
            style={{
              position: 'fixed',
              width: '100%',
              height: '100vh',
              top: 0,
              right: 0,
              zIndex: 999999,
              opacity: '.7',
            }}
          ></div>
          <div
            className='d-flex d-md-none'
            style={{
              position: 'fixed',
              width: '70%',
              height: '100vh',
              top: 0,
              right: 0,
              zIndex: 99999999999999,
              background: '#6667AB',
            }}
          >
            <div className='d-flex flex-column w-100'>
              <div className='d-flex flex-row w-100 justify-content-end align-items-end'>
                <i
                  className='fas fa-times f-24 text-white my-2 mx-3'
                  onClick={() => setShowMobileMenu(false)}
                ></i>
              </div>

              <div className='d-flex flex-column justify-content-center align-content-center align-items-center w-100 mb-3 border-bottom pb-2'>
                <img
                  src={Logo}
                  alt='logo'
                  className='mt-2 text-center mx-auto'
                  style={{ width: '90px' }}
                />
              </div>
              <ul className='d-flex flex-column mx-0 px-0'>
                <li
                  className='d-flex flex-row align-items-center'
                  style={{ padding: '11px 0' }}
                >
                  <Link
                    to='/'
                    className='text-white f-13 d-flex flex-row align-items-center'
                  >
                    <i className='fas fa-home text-white f-18 mx-2'></i>
                    صفحه اصلی
                  </Link>
                </li>
                <li
                  className='d-flex flex-row align-items-center'
                  style={{ padding: '11px 0' }}
                >
                  <Link
                    to='/'
                    className='text-white f-13 d-flex flex-row align-items-center'
                  >
                    <i className='fas fa-address-card text-white f-18 mx-2'></i>
                    درباره فدراسیون
                  </Link>
                </li>{' '}
                <li
                  className='d-flex flex-row align-items-center'
                  style={{ padding: '11px 0' }}
                >
                  <Link
                    to='/payment/tracking'
                    className='text-white f-13 d-flex flex-row align-items-center'
                  >
                    <i className='fas fa-credit-card text-white f-18 mx-2'></i>
                    پرداخت از طریق کد پیگیری
                  </Link>
                </li>
                <li
                  className='d-flex flex-row align-items-center'
                  style={{ padding: '11px 0' }}
                >
                  <Link
                    to='/id-card'
                    className='text-white f-13 d-flex flex-row align-items-center'
                  >
                    <i className='fas fa-id-card text-white f-18 mx-2'></i>
                    دریافت آی دی کارت
                  </Link>
                </li>
                <li
                  className='d-flex flex-row align-items-center'
                  style={{ padding: '11px 0' }}
                >
                  <a
                    target='_blank'
                    rel='noreferrer noopener'
                    className='text-white f-13 d-flex flex-row align-items-center'
                    href='https://athlete.ifsm.ir/Login'
                  >
                    <i className='fas fa-briefcase-medical text-white f-18 mx-2'></i>
                    سامانه پزشکی ورزشی
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
};

Master.propTypes = {
  showSidebar: PropTypes.bool,
  containerFullWidth: PropTypes.bool,
};

export default Master;
